import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import 'hammerjs';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
// SA-8637: defensive guard — `Sentry` is populated by the CDN <script> in
// index.html. If that script failed to load (network / CSP / blocked), skip
// init rather than crash bootstrap.
if (environment.sentry.dsn && typeof Sentry !== 'undefined') {
    Sentry.init({
        dsn: environment.sentry.dsn,
        environment: environment.environment,
        enableLogs: true,
        maxBreadcrumbs: 30,
        ignoreErrors: [
            // Browser / rendering noise
            'ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications',
            // Chunk loading (transient network issues)
            'Loading chunk',
            'ChunkLoadError',
            // Browser extension errors
            'Extension context invalidated',
            // Non-actionable Angular zone errors
            "Cannot read properties of null (reading 'nativeElement')",
            "Cannot read property 'nativeElement' of null"
        ],
        denyUrls: [
            // Browser extensions
            /extensions\//i,
            /^chrome:\/\//i,
            /^chrome-extension:\/\//i,
            /^moz-extension:\/\//i,
            // Analytics / third-party
            /hotjar\.com/i
        ],
        beforeSend: function (event) {
            // Always allow explicitly tagged events through (e.g. script-loader, effects, auth)
            if (event.tags && event.tags['source']) {
                return event;
            }
            // Drop untagged events without a stacktrace (usually noise from global handler)
            if (event.exception &&
                event.exception.values &&
                event.exception.values.length > 0) {
                var hasStacktrace = event.exception.values.some(function (v) {
                    return v.stacktrace &&
                        v.stacktrace.frames &&
                        v.stacktrace.frames.length > 0;
                });
                if (!hasStacktrace) {
                    return null;
                }
            }
            return event;
        }
    });
    Sentry.setTag('clinic', window.location.hostname.split('.')[0]);
}
if (environment.production) {
    enableProdMode();
}
__NgCli_bootstrap_2.platformBrowser().bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory)
    .catch(function (err) { return console.error(err); });
